import draw from "./postcoronaDraw";

draw();
